const layoutConfig = {
  headerConfig: { showSearch: true, hideCity: true },
  footerConfig: {},
  supportConfig: {
    enabled: false
  }
}

const translationNamespaces = ['translation', 'states', 'cities']

export { layoutConfig, translationNamespaces }
